import React, { useState, useEffect } from "react";
import Modal from "react-modal/lib/components/Modal";
import HeaderSimple from "../../../../components/header/simple";
import { BtnBack } from "../../../../components/button/button-back";
import reqComplementos from "../../../../services/reqMultiTenant/reqComplementos";
import Notification from "../../../../components/toast";
import { Plus, Trash2, Search, ListChecks } from "lucide-react";
import ProductSearch from "../../../../components/product-search";

function ModalSelectProductsItem({ isOpen, handleClose, grupoSelecionado, fetchItens }) {
	const [isSaving, setIsSaving] = useState(false);
	const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

	// Controle de Abas
	const [activeTab, setActiveTab] = useState("search"); // 'search' | 'selected'

	// Lista de produtos que estão sendo marcados para adicionar como itens
	const [itensSelecionados, setItensSelecionados] = useState([]);

	useEffect(() => {
		if (isOpen) {
			setHasUnsavedChanges(false);
			setActiveTab("search");
			setItensSelecionados([]);
		}
	}, [isOpen]);

	// Prevenção de fechamento
	const handleSafeClose = () => {
		if (hasUnsavedChanges) {
			const leave = window.confirm("Existem itens selecionados não salvos! Deseja realmente sair sem salvar?");
			if (!leave) return;
		}
		handleClose();
	};

	// Função que recebe o Produto clicado lá de dentro do `<ProductSearch />`
	const handleAddItem = (prod) => {
		const prodId = prod.id_produto || prod.id;
		const jaExiste = itensSelecionados.find((v) => v.id_produto === prodId);
		
		if (jaExiste) {
			Notification.showToast({ message: "Produto já está na lista de seleção!", type: "info" });
			return;
		}

		setItensSelecionados((prev) => [...prev, { 
            id_produto: prodId, 
            nome_produto: prod.nome,
            valor: prod.valor || 0
        }]);
		setHasUnsavedChanges(true);
		Notification.showToast({
			message: "Produto adicionado à lista. Selecione mais ou clique em Salvar Itens!",
			type: "success",
		});
	};

	const handleRemoveItem = (idProd) => {
		setItensSelecionados((prev) => prev.filter((v) => v.id_produto !== idProd));
		if (itensSelecionados.length === 1) { // Estava com 1, agora vai pra 0
			setHasUnsavedChanges(false);
		}
	};

	// Grava de volta no servidor
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (itensSelecionados.length === 0) {
			handleClose();
			return;
		}

		setIsSaving(true);
		try {
			// Monta o array que a API inserirItens espera
			const payloadArray = itensSelecionados.map((item) => ({
				id_complementos_item: 0,
				id_produto: item.id_produto,
				id_complementos_grupo: grupoSelecionado.id_complementos_grupo,
				nome: item.nome_produto,
				descricao: "",
				qtde: 1,
				valor_item: item.valor,
				ordem: 0,
				ativo: true,
			}));

			await reqComplementos.inserirItens(payloadArray);

			Notification.showToast({
				message: `${payloadArray.length} iten(s) adicionado(s) com sucesso!`,
				type: "success",
			});
			
			if (fetchItens) {
				await fetchItens();
			}
			
			handleClose();
		} catch (error) {
			console.error(error);
			const msg = error.response?.data?.message || error.message || "Erro desconhecido";
			Notification.showToast({
				message: "Erro ao inserir itens: " + msg,
				type: "error",
			});
		} finally {
			setIsSaving(false);
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={handleSafeClose}
			overlayClassName="react-modal-overlay"
			className="modal-content-form modal-product-resize"
			shouldCloseOnOverlayClick={false}
		>
			<div
				className="flex flex-col h-full bg-white rounded shadow-xl overflow-hidden"
				style={{ maxHeight: "90vh" }}
			>
				<HeaderSimple
					title="Adicionar Itens ao Grupo"
					subTitle={`Grupo Atual: ${grupoSelecionado?.descricao || ""}`}
					handleCloseModalRegister={handleSafeClose}
				/>

				{/* Navbar de Abas */}
				<div className="flex border-b bg-gray-50/50 px-4 mt-2 shrink-0">
					<button
						onClick={() => setActiveTab("search")}
						className={`py-3 px-4 font-medium text-sm flex items-center gap-2 border-b-2 transition-colors ${
							activeTab === "search"
								? "border-blue-600 text-blue-600 bg-blue-50/30"
								: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
						}`}
					>
						<Search size={16} />
						Pesquisar Produtos
					</button>

					<button
						onClick={() => setActiveTab("selected")}
						className={`py-3 px-4 font-medium text-sm flex items-center gap-2 border-b-2 transition-colors ${
							activeTab === "selected"
								? "border-blue-600 text-blue-600 bg-blue-50/30"
								: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
						}`}
					>
						<ListChecks size={16} />
						Itens Prontos p/ Adicionar
						<span
							className={`ml-2 px-2 py-0.5 rounded-full text-xs text-white ${activeTab === "selected" ? "bg-blue-600" : "bg-gray-400"}`}
						>
							{itensSelecionados.length}
						</span>
					</button>
				</div>

				<form onSubmit={handleSubmit} className="form flex-1 flex flex-col overflow-hidden h-full">
					<main className="flex-1 flex flex-col overflow-hidden min-h-0 p-4 bg-gray-100">
						{/* ABA 1: PESQUISA */}
						{activeTab === "search" && (
							<div className="flex-1 flex flex-col min-h-0 animate-fade-in">
								<div className="flex-1 flex flex-col shadow-sm rounded-md border border-gray-300 bg-white overflow-hidden min-h-0">
									<ProductSearch
										key={isOpen ? "open" : "closed"}
										onSelectProduct={handleAddItem}
										onRemoveProduct={handleRemoveItem}
										customActionTitle="Selecionar para o Grupo"
										customActionIcon={<Plus size={16} />}
										linkedIds={itensSelecionados.map((v) => v.id_produto)}
									/>
								</div>
							</div>
						)}

						{/* ABA 2: LISTA DE ESCOLHIDOS */}
						{activeTab === "selected" && (
							<div className="flex-1 flex flex-col min-h-0 border rounded-md shadow-sm border-gray-300 bg-white animate-fade-in overflow-hidden">
								<div className="flex-1 overflow-y-auto w-full">
									<table className="table table-hover mb-0 w-full table-fixed">
										<thead className="color-table sticky top-0 z-10 shadow-sm border-b">
											<tr>
												<th className="text-left font-semibold py-2 px-4 shadow-sm">
													<div className="flex items-center gap-2">
														<span className="text-color-table">Produtos Selecionados ({itensSelecionados.length})</span>
													</div>
												</th>
												<th className="text-right font-semibold py-2 px-4 w-20 shadow-sm"><span className="text-color-table">Ação</span></th>
											</tr>
										</thead>
										<tbody>
											{itensSelecionados.length > 0 ? (
												itensSelecionados.map((prod) => (
													<tr
														key={prod.id_produto}
														className="group border-b last:border-0 hover:bg-red-50"
													>
														<td className="text-left font-medium align-middle py-3 px-4 text-gray-800">
															{prod.nome_produto}
															<span className="ml-2 text-xs text-green-700 bg-green-100 px-2 py-0.5 rounded-full font-semibold">
																Pronto p/ Inserir
															</span>
														</td>
														<td className="text-right align-middle py-3 px-4 w-20">
															<button
																type="button"
																title="Remover produto da lista"
																className="text-gray-400 hover:text-red-600 transition-colors p-2 rounded-full hover:bg-red-100"
																onClick={() => handleRemoveItem(prod.id_produto)}
															>
																<Trash2 size={18} />
															</button>
														</td>
													</tr>
												))
											) : (
												<tr>
													<td
														colSpan="2"
														className="text-center text-gray-500 py-12 px-4 shadow-inner bg-gray-50 border-t"
													>
														<div className="flex flex-col items-center gap-3">
															<ListChecks size={40} className="text-gray-300" />
															<span className="text-base text-gray-600">
																Nenhum produto selecionado.
															</span>
															<span className="text-sm">
																Vá até a aba{" "}
																<strong
																	className="cursor-pointer text-blue-600 underline"
																	onClick={() => setActiveTab("search")}
																>
																	Pesquisar Produtos
																</strong>{" "}
																e selecione as opções desejadas.
															</span>
														</div>
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</div>
						)}
					</main>

					<footer className="mt-auto border-t pt-3 pb-2 px-4 bg-gray-50/80 shrink-0 flex justify-between items-center z-20">
						<BtnBack onClick={handleSafeClose} isSubmitting={isSaving} />
						<div className="flex gap-2 ml-auto">
							<button
								type="submit"
								className="btn btn-success font-medium px-4 py-2 flex items-center justify-center gap-2"
								disabled={isSaving || itensSelecionados.length === 0}
							>
								{isSaving ? (
									<>
										<span
											className="spinner-border spinner-border-sm"
											role="status"
											aria-hidden="true"
										></span>
										Salvando Itens...
									</>
								) : (
									`Salvar Itens (${itensSelecionados.length})`
								)}
							</button>
						</div>
					</footer>
				</form>
			</div>
		</Modal>
	);
}

export default ModalSelectProductsItem;
